import {createSelector} from "reselect";
import {buildArticleOptionDisplayData} from "./Util";
import {getCurrentProduct, getSelectedAccount, getSelectedArticle} from "./ProductSelection";
import {getAccounts, getCart} from "./SimpleSelectors";
import {delve} from "../util/util";
import {getArticleOptionsInCartObject} from "./CartUtil";

// **************************************************************************************************************

export const getHddOptionDisplayData = createSelector(
    [
        state => state.articleData.articleOptions,
        state => state.articleData.articleOptionCollection[state.articleData.baseArticle.articleNumber].hardware.hddSw,
        getCurrentProduct,
        getSelectedAccount,
        getAccounts,
        getSelectedArticle,
        getCart,
        getArticleOptionsInCartObject
    ],
    (
        articleOptions,
        articleNumbers,
        currentProduct,
        account,
        accounts,
        selectedArticle,
        cart
    ) => {

        if (articleNumbers) {

            const regex = /(\d{1,})/

            // calculate minUsageGb if different product is selected
            let minUsageGB = currentProduct !== selectedArticle ? account ? delve(accounts, account + ".stats.summary") / 1024 / 1024 : 0 : 0

            const inclusiveStorageGB = articleNumbers.indexOf("default_hddSw") >= 0 ? regex.exec(articleOptions["default_hddSw"].title)[1] : 0

            if (delve(cart, "initParams.minSelectedUsageGB")) {
                minUsageGB = Math.max(minUsageGB, Number(inclusiveStorageGB) + Number(delve(cart, "initParams.minSelectedUsageGB")));
            }

            return articleNumbers.map(articleNumber => buildArticleOptionDisplayData(articleOptions, articleNumber)).sort((a, b) => {
                return a.display.price.priceMonthly - b.display.price.priceMonthly
            }).map(option => {

                const optionMaxUsageGB = regex.exec(option.display.title)[1]
                const isInclusiveOption = option.value.indexOf("default_") >= 0

                let disabled = false;

                // check if inclusive storage plus option storage would be enough to fit the minUsageGB
                return Object.assign({}, option, {disabled});

            })
        } else {
            return []
        }
    }
)

export const getCustomDisplayData = (state, articleNumbers) => {
    const articleOptions = state.articleData.articleOptions
    if (articleNumbers) {
        return articleNumbers.map(articleNumber => buildArticleOptionDisplayData(articleOptions, articleNumber)).filter(Boolean);
    } else {
        return []
    }
}



/** WEBPACK FOOTER **
 ** ./src/selectors/Hardware.js
 **/